export default __webpack_public_path__ + "6d20cff5b3255dd0078f935c34e2b882.woff2";